import { ElMessage } from 'element-plus';

export default class INotify {
  static error(message: string) {
    this.notify('error', message);
  }
  static info(message: string) {
    this.notify('info', message);
  }

  static success(message: string) {
    this.notify('success', message);
  }

  static warning(message: string) {
    this.notify('warning', message);
  }

  private static notify(type: string, message: string) {
    ElMessage({
      // @ts-ignore
      customClass: 'i-notify',
      grouping: true,
      message,
      offset: 80,
      type,
    });
  }
}
